/*
 * File: huddle-notes.service.ts
 * Project: a-a
 * File Created: Friday, 12th December 2025 1:15:29 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 12th December 2025 1:18:48 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { INotesAddPayload, INotesDeletePayload, INotesEditPayload } from '../model/notes.model';

import { ApiConstants } from './api-constants';
import { HuddleApiConstants } from './huddle-api-constants';
export class HuddleNotesService {
  static getAllNotes = async (id: string) => {
    return await (
      await axios.get(HuddleApiConstants.NOTES_API.ALL_NOTES.URL(id))
    ).data;
  };
  static addNotes = async (params: INotesAddPayload) => {
    return await (
      await axios.post(HuddleApiConstants.NOTES_API.ADD_EDIT_NOTES.URL(), params)
    ).data;
  };
  static EditNotes = async (params: INotesEditPayload) => {
    return await (
      await axios.patch(HuddleApiConstants.NOTES_API.ADD_EDIT_NOTES.URL(), params)
    ).data;
  };
  static deleteNotes = async (id: string, params: INotesDeletePayload) => {
    return await (
      await axios.delete(HuddleApiConstants.NOTES_API.ALL_NOTES.URL(id), { data: { ...params } })
    ).data;
  };
}
